import axios from 'axios';
const apiUrl = process.env.VUE_APP_API_URL_PAYCHANGU;

const createDeposit = async (json) => {
  try {

    // Hacer la solicitud POST
    const response = await axios.post(`${apiUrl}/api/deposit/card/create`, json, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // Extraer el código de error, si es un número


    // Verificar si el código de error está en la lista de códigos de error
    if (response.status === 200 && response.data ) {
      // window.location.reload();
      console.log(response.data.data);
      return   {
        success: true,
        message: 'Deposit created successfully',
        data: response.data.data
      };  // Retorna el éxito
    }

  } catch (error) {
    // Manejo de errores
    console.error('There was an error!', error);
    if (error.response) {
      console.error("Response Error:", error.response.data);
      return {
        success: false,
        message: error.response.data.message || 'An error occurred while fetching transactions.',
      };
    } 
    // No hubo respuesta del servidor
    else if (error.request) {
      console.error("No response received from the server.");
      return {
        success: false,
        message: 'No response received from the server. Please check your network connection.',
      };
    } 
    // Error en la configuración de la solicitud
    else {
      console.error("Error during request setup:", error.message);
      return {
        success: false,
        message: 'An error occurred while trying to fetch transactions. Please try again.',
      };
    }
  } 
};

// get bank account details for direct bank deposit

const getBankAccountDetails = async (json) => {
  /** response: {
    "code": 0,
    "message": "",
    "data": {
        "username": null,
        "transaction_type_id": null,
        "bank_name": "Centenary Bank",
        "account_number": "2652377091",
        "account_name": "Carlos Julio",
        "exist": true
    }
} */
  try {

    // Hacer la solicitud POST
    const response = await axios.post(`${apiUrl}/api/deposit/direct-bank/getbankaccount`, json, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (response.status === 200 && response.data ) {
      // window.location.reload();
      console.log(response.data.data);  
      return   {
        success: true,
        message: 'Bank account details retrieved successfully',
        data: response.data.data
      };  // Retorna el éxito
    }

  } catch (error) {
    // Manejo de errores
    console.error('There was an error!', error);
    if (error.response) {
      console.error("Response Error:", error.response.data);
      return {
        success: false,
        message: error.response.data.message || 'An error occurred while fetching bank account details.',
      };
    } 
    // No hubo respuesta del servidor
    else if (error.request) {
      console.error("No response received from the server.");
      return {
        success: false,
        message: 'No response received from the server. Please check your network connection.',
      };
    } 
    // Error en la configuración de la solicitud
    else {
      console.error("Error during request setup:", error.message);
      return {
        success: false,
        message: 'An error occurred while trying to fetch bank account details. Please try again.',
      };
    }
  } 

}

const generateacountbank = async (json) => {
  // reponse example 
  /** 
   * {
    "code": 0,
    "message": "",
    "data": {
        "payment_account_details": {
            "bank_name": "Centenary Bank",
            "account_number": "2652325197",
            "account_name": "Carlos Julio"
        }
    }
}
   */
  try {

    // Hacer la solicitud POST
    const response = await axios.post(`${apiUrl}/api/deposit/direct-bank/create`, json, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // Extraer el código de error, si es un número


    // Verificar si el código de error está en la lista de códigos de error
    if (response.status === 200 && response.data ) {
      // window.location.reload();
      console.log(response.data.data);
      return   {
        success: true,
        message: 'Deposit created successfully',
        data: response.data.data
      };  // Retorna el éxito
    }

  } catch (error) {
    // Manejo de errores
    console.error('There was an error!', error);
    if (error.response) {
      console.error("Response Error:", error.response.data);
      return {
        success: false,
        message: error.response.data.message || 'An error occurred while fetching transactions.',
      };
    } 
    // No hubo respuesta del servidor
    else if (error.request) {
      console.error("No response received from the server.");
      return {
        success: false,
        message: 'No response received from the server. Please check your network connection.',
      };
    } 
    // Error en la configuración de la solicitud
    else {
      console.error("Error during request setup:", error.message);
      return {
        success: false,
        message: 'An error occurred while trying to fetch transactions. Please try again.',
      };
    }
  } 

}
export default { createDeposit, generateacountbank, getBankAccountDetails };